// Helper function to calculate out of service duration
export const getOutOfServiceDuration = (outOfServiceDate) => {
  if (!outOfServiceDate) return null;
  
  const start = new Date(outOfServiceDate);
  const now = new Date();
  const diffMs = now - start;
  
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  
  if (days > 0) {
    return `${days}d ${hours}h`;
  }
  return `${hours}h`;
};

// Format number with commas
export const formatNumber = (num) => {
  if (num === null || num === undefined) return '';
  return num.toLocaleString();
};

// Parse comma-formatted number string
export const parseFormattedNumber = (str) => {
  if (!str) return 0;
  return parseInt(String(str).replace(/,/g, '')) || 0;
};
